module.exports = [{
      plugin: require('/zeit/6280037f/node_modules/gatsby-plugin-gtag/gatsby-browser.js'),
      options: {"plugins":[],"head":false,"anonymize":true},
    }]
